<template>

  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col
            class="content-header-left mb-2"
            cols="12"
            md="12"
          >
            <b-row class="breadcrumbs-top">
              <b-col cols="12">
                <h1 class="custom-header-title">
                  Create new Reservation
                </h1>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- Table Container Card -->
    <b-form @submit.prevent="submitForm">
      <validation-observer
        ref="reservationCreateForm"
      >
        <b-card
          header-tag="header"
        >
          <template #header>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="button"
              variant="flat-primary"
              class="primary-button-with-background mr-3"
            >
              <feather-icon
                icon="GridIcon"
                class=""
                size="20"
              />
            </b-button>
            <h3 class="align-middle mr-auto">
              Lot Information
            </h3>
            <div
              class="ml-auto"
            >
              <span class="">You've selected:</span> <span v-if="lotData._id">
                <span class="weight-700">{{ lotData.zoneLotNo }}</span> &bull; <span class="weight-700">{{ lotData.lotType }}</span>
                <b-badge
                  :variant="`light-${resolveStatusVariant(lotData.status)}`"
                  class="ml-50 weight-600 text-capitalize"
                >
                  <span>{{ resolveStatusName(lotData.status) }}</span>
                </b-badge>
              </span> <span v-else>-</span>
            </div>
          </template>
          <b-row>
            <b-col
              v-if="lotData.status && lotData.status != 'OPEN'"
              cols="md-12"
            >
              <b-alert
                variant="danger"
                show
                class="danger__alert"
              >
                <div class="alert-body has-radius">
                  <span>
                    <feather-icon
                      size="20"
                      icon="AlertTriangleIcon"
                      class="mr-25"
                    /> <div class="alert_text">This lot is no longer available to be reserved as it has been reserved by someone else.</div>
                  </span>
                </div>
              </b-alert>
            </b-col>
            <b-col cols="md-6">
              <b-form-group
                label="Suite*"
                label-for="h-booking-suiteName"
                label-cols-md="4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Suite"
                  vid="suiteName"
                  rules="required"
                >
                  <b-input-group>
                    <b-form-input
                      id="search_name"
                      v-model="suiteQuery"
                      label="Suite"
                      name="name"
                      placeholder="Search Suite Name or Code"
                      autocomplete="off"
                      tabindex="0"
                      :class="!showSuiteCrossIcon ? 'input__append-border-right' : ''"
                      :disabled="showSuiteCrossIcon"
                      @keyup="fetchSuiteResults()"
                      @focusout="resetSuiteSearchResult"
                    />
                    <b-input-group-append
                      v-if="showSuiteCrossIcon"
                      is-text
                    >
                      <feather-icon
                        icon="XIcon"
                        class="cursor-pointer text-primary"
                        size="18"
                        data-toggle
                        @click="clearSuiteSearchInput"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <div
                    v-show="showSuiteSearchResult"
                    class="search-results mt-50 z-index-99"
                  >
                    <div v-if="foundSuites.length">
                      <b-list-group flush>
                        <b-list-group-item>
                          <h3 class="mb-0 result-search-header">
                            Suites found
                          </h3>
                        </b-list-group-item>
                        <b-list-group-item
                          v-for="(suite, sIndex) in foundSuites"
                          :key="sIndex"
                          class="cursor-pointer"
                          @click="addSuiteSearchInput(suite)"
                        >
                          <div class="d-flex">
                            <b-img
                              class="item-img-block suite-img"
                              :src="suite.image ? suite.image : defaultImage"
                            />
                            <div
                              class="search-item-text-block align-self-center"
                            >
                              <h6 class="text-primary">
                                {{ suite.description }}
                              </h6>
                              <small>{{ suite.code }}</small>
                            </div>
                          </div>
                        </b-list-group-item>
                      </b-list-group>
                    </div>
                  </div>
                  <div
                    v-show="searchSuiteResultNotFound"
                    class="search-results mt-50 z-index-99"
                  >
                    <b-list-group>
                      <b-list-group-item>
                        <h3 class="mb-0 result-search-header">
                          No result found.
                        </h3>
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="suiteNameValidation"
                    class="text-danger"
                  >
                    {{ suiteNameError }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="md-6" />

            <b-col cols="md-6">
              <b-form-group
                label="Lot*"
                label-for="h-booking-lotName"
                label-cols-md="4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Lot"
                  vid="lotName"
                  rules="required"
                >
                  <b-input-group>
                    <b-form-input
                      id="search_lot"
                      v-model="lotQuery"
                      label="Lot"
                      name="name"
                      placeholder="Search Lot"
                      autocomplete="off"
                      tabindex="0"
                      :class="{'input__append-border-right': !showLotCrossIcon, 'is_invalid': errors[0]}"
                      :disabled="showLotCrossIcon"
                      @keyup="fetchLotResults()"
                      @focusout="resetLotSearchResult"
                    />
                    <b-input-group-append
                      v-if="showLotCrossIcon"
                      is-text
                    >
                      <feather-icon
                        icon="XIcon"
                        class="cursor-pointer text-primary"
                        size="18"
                        data-toggle
                        @click="clearLotSearchInput"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <div
                    v-show="showLotSearchResult"
                    class="search-results mt-50 z-index-99"
                  >
                    <div v-if="foundLots.length">
                      <b-list-group flush>
                        <b-list-group-item>
                          <h3 class="mb-0 result-search-header">
                            Lots found
                          </h3>
                        </b-list-group-item>
                        <b-list-group-item
                          v-for="(lot, sIndex) in foundLots"
                          :key="sIndex"
                          class="cursor-pointer"
                          @click="addLotSearchInput(lot)"
                        >
                          <div class="d-flex">
                            <div
                              class="search-item-text-block no-ml align-self-center"
                            >
                              <h6 class="text-primary">
                                {{ lot.lotNo }}
                              </h6>
                            </div>
                          </div>
                        </b-list-group-item>
                      </b-list-group>
                    </div>
                  </div>
                  <div
                    v-show="searchLotResultNotFound"
                    class="search-results mt-50 z-index-99"
                  >
                    <b-list-group>
                      <b-list-group-item>
                        <h3 class="mb-0 result-search-header">
                          No result found.
                        </h3>
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="lotNameValidation"
                    class="text-danger"
                  >
                    {{ lotNameError }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="md-6" />

            <b-col cols="md-6">
              <b-form-group
                label="Reserved For"
                label-for="h-booking-reservedFor"
                label-cols-md="4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Reserved For"
                  vid="reservedFor"
                  rules=""
                >
                  <b-form-input
                    id="h-booking-reservedFor"
                    v-model="reservedFor"
                    placeholder="Reserved For"
                    :state="(errors.length > 0 || reservedForValidation) ? false : null"
                    name="reservedFor"
                    @input="reservedForValidation == true ? reservedForValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="reservedForValidation"
                    class="text-danger"
                  >
                    {{ reservedForError }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="md-6" />

            <b-col
              cols="12"
              class="textarea-padding"
            >
              <b-form-group
                label="Remarks"
                label-for="h-booking-remarks"
                label-cols-md="2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Remarks"
                  vid="remarks"
                  rules=""
                >
                  <b-form-textarea
                    id="event-remarks"
                    v-model="remarks"
                    placeholder="Remarks"
                    rows="3"
                    name="remarks"
                    @input="remarksValidation == true ? remarksValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="remarksValidation"
                    class="text-danger"
                  >
                    {{ remarksError }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="md-6">
              <validation-provider
                #default="{ errors }"
                name="Type of Reservation"
                vid="reservationStatus"
                rules="required"
              >
                <b-form-group
                  label="Type of Reservation*"
                  label-for="h-bookings-reservationStatus"
                  label-cols-md="4"
                  :state="(errors.length > 0 || reservationStatusValidation) ? false : null"
                >
                  <v-select
                    id="h-bookings-reservationStatus"
                    v-model="reservationStatus"
                    label="title"
                    placeholder="Select from list"
                    :options="reservationStatusOptions"
                    :selectable="isSelectableOption"
                    :reduce="title => title.code"
                    :clearable="false"
                    @input="reservationStatusValidation == true ? reservationStatusValidation = false : null"
                  >
                    <template #option="option">
                      <div
                        :style="{
                          opacity: option.code === 'HOLD' && !canCreateStaffHold ? '0.3' : '1',
                        }"
                      >
                        {{ option.title }}
                      </div>
                    </template>
                  </v-select>

                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="reservationStatusValidation"
                    class="text-danger"
                  >
                    {{ reservationStatusError }}
                  </small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6" />
            <b-col cols="2" />
            <b-col
              cols="10"
              class="pl-50 custom-description"
            >
              <small class="text-muted">Only privileged staff can create a Staff Hold reservation. Staff Hold reservations can be indefinite in duration.</small>
            </b-col>
            <b-col
              v-if="reservationStatus == 'HOLD'"
              cols="md-6"
            >
              <b-form-group
                label="Release Date and Time"
                label-for="h-event-releaseDate"
                label-cols-md="4"
              >
                <b-input-group>
                  <flat-pickr
                    id="h-event-releaseDate"
                    v-model="releaseDate"
                    class="form-control flat-pickr-group"
                    placeholder="Indefinitely"
                    :config="flatPickrConfig"
                    @input="releaseDateValidation == true ? releaseDateValidation = false : null"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      icon="CalendarIcon"
                      class="cursor-pointer"
                      data-toggle
                      size="18"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small
                  v-if="releaseDateValidation"
                  class="text-danger"
                >
                  {{ releaseDateError }}
                </small>
              </b-form-group>
            </b-col>
            <b-col
              v-if="reservationStatus == 'HOLD'"
              cols="6"
            >
              <b-button
                type="button"
                variant="link"
                @click="setReleaseDate('48', 'hours')"
              >
                48 hours
              </b-button>

              <b-button
                type="button"
                variant="link"
                @click="setReleaseDate('1', 'week')"
              >
                1 week
              </b-button>

              <b-button
                type="button"
                variant="link"
                @click="setReleaseDate('1', 'month')"
              >
                1 month
              </b-button>

              <b-button
                type="button"
                variant="link"
                @click="setReleaseDate()"
              >
                Indefinitely
              </b-button>
            </b-col>
          </b-row>
        </b-card>

        <b-card
          header-tag="header"
        >
          <template #header>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="button"
              variant="flat-primary"
              class="primary-button-with-background mr-3"
            >
              <feather-icon
                icon="GridIcon"
                class=""
                size="20"
              />
            </b-button>
            <h3 class="align-middle mr-auto">
              Agent Details
            </h3>
          </template>
          <b-row>
            <b-col cols="md-6">
              <b-form-group
                label="Agent Name*"
                label-for="h-booking-agentName"
                label-cols-md="4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Agent Name"
                  vid="agentName"
                  rules="required"
                >
                  <b-input-group>
                    <b-form-input
                      id="search_agent_name"
                      v-model="agentQuery"
                      label="Agent Name*"
                      name="name"
                      placeholder="Search Agent Name or Code"
                      autocomplete="off"
                      tabindex="0"
                      :class="!showAgentCrossIcon ? 'input__append-border-right' : ''"
                      :disabled="showAgentCrossIcon"
                      @keyup="fetchAgentResults()"
                      @focusout="resetAgentSearchResult"
                    />
                    <b-input-group-append
                      v-if="showAgentCrossIcon"
                      is-text
                    >
                      <feather-icon
                        icon="XIcon"
                        class="cursor-pointer text-primary"
                        size="18"
                        data-toggle
                        @click="clearAgentSearchInput"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <div
                    v-show="showAgentSearchResult"
                    class="search-results mt-50 z-index-99"
                  >
                    <div v-if="foundAgents.length">
                      <b-list-group flush>
                        <b-list-group-item>
                          <h3 class="mb-0 result-search-header">
                            Agents found
                          </h3>
                        </b-list-group-item>
                        <b-list-group-item
                          v-for="(agent, cIndex) in foundAgents"
                          :key="cIndex"
                          class="cursor-pointer"
                          @click="setAgent(agent)"
                        >
                          <h6 class="mb-0 fs-14 text-primary">
                            {{ agent.name }}
                          </h6>
                          <p class="mb-0 fs-12">
                            {{ agent.code }}
                          </p>
                        </b-list-group-item>
                      </b-list-group>
                    </div>
                  </div>
                  <div
                    v-show="searchAgentResultNotFound"
                    class="search-results mt-50 z-index-99"
                  >
                    <b-list-group>
                      <b-list-group-item>
                        <h3 class="mb-0 result-search-header">
                          No result found.
                        </h3>
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="agentNameValidation"
                    class="text-danger"
                  >
                    {{ agentNameError }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="md-6" />

            <b-col cols="md-6">
              <b-form-group
                label="Agent Code*"
                label-for="h-booking-agentCode"
                label-cols-md="4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Agent Code"
                  vid="agentCode"
                  rules=""
                >
                  <b-form-input
                    id="h-booking-agentCode"
                    v-model="agentCode"
                    placeholder="Agent Code"
                    :state="(errors.length > 0 || agentCodeValidation) ? false : null"
                    :disabled="showAgentCrossIcon"
                    name="agentCode"
                    @input="agentCodeValidation == true ? agentCodeValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="agentCodeValidation"
                    class="text-danger"
                  >
                    {{ agentCodeError }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="md-6" />
          </b-row>
        </b-card>

        <b-nav class="wrap-border save-nav">
          <li
            class="nav-item ml-auto"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="button"
              variant="flat-primary"
              @click="goBack()"
            >
              Cancel
            </b-button>
          </li>
          <li
            class="nav-item mr-1"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-50"
              />
              <span class="align-middle">Create new Reservation</span>
            </b-button>
          </li>
        </b-nav>
      </validation-observer>
    </b-form>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BFormTextarea, BForm, BButton, BNav, VBTooltip,
  BListGroup, BListGroupItem, BImg, BBadge, BAlert,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import moment from 'moment'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import { heightTransition } from '@core/mixins/ui/transition'

const { canViewThisAction } = useAclUtils()

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BForm,
    BButton,
    BNav,
    BInputGroup,
    BInputGroupAppend,
    BListGroup,
    BListGroupItem,
    BImg,
    BBadge,
    BAlert,

    vSelect,
    flatPickr,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
  },
  directives: { 'b-tooltip': VBTooltip, Ripple },
  mixins: [heightTransition],
  data() {
    return {
      // eslint-disable-next-line global-require
      defaultImage: require('@/assets/images/placeholder/placeholder_image.png'),
      suiteQuery: '',
      suiteName: '',
      suiteID: '',
      searchSuite: false,
      showSuiteCrossIcon: false,
      showSuiteSearchResult: false,
      searchSuiteResultNotFound: false,
      foundSuites: [],
      lotQuery: '',
      lotName: '',
      lotID: '',
      lotData: {},
      searchLot: false,
      showLotCrossIcon: false,
      showLotSearchResult: false,
      searchLotResultNotFound: false,
      foundLots: [],
      showAgentCrossIcon: false,
      showAgentSearchResult: false,
      searchAgentResultNotFound: false,
      foundAgents: [],
      agentID: '',
      pAgentID: '',
      sclcAgentID: '',
      agentType: '',
      agentName: '',
      agentCode: '-',
      searchAgent: false,
      agentQuery: '',
      agentResults: [],
      agentSuggestions: [],
      reservedFor: '',
      remarks: '',
      releaseDate: '',
      reservationStatus: 'RESERVE',
      timeout: null,
      selected: null,
      debounceMilliseconds: 1000,
      suiteNameError: 'Valid name is required',
      suiteNameValidation: false,
      lotNameError: 'Valid name is required',
      lotNameValidation: false,
      agentNameError: 'Valid value is required',
      agentNameValidation: false,
      agentCodeError: 'Valid value is required',
      agentCodeValidation: false,
      reservedForError: 'Valid value is required',
      reservedForValidation: false,
      releaseDateError: 'Valid value is required',
      releaseDateValidation: false,
      remarksError: 'Valid value is required',
      remarksValidation: false,
      reservationStatusError: 'Valid value is required',
      reservationStatusValidation: false,
      savedData: false,
      reservationStatusOptions: [
        { title: 'Reserved', code: 'RESERVE' },
        { title: 'Staff Hold', code: 'HOLD' },
      ],
      flatPickrConfig: {
        wrap: true, enableTime: true, dateFormat: 'd/m/Y, H:i', minDate: 'today', disableMobile: true,
      },
      statusOptions: [
        { title: 'Available', code: 'OPEN' },
        { title: 'Reserved', code: 'RESERVE' },
        { title: 'Booked', code: 'BOOK' },
        { title: 'Confirmed', code: 'CONFIRM' },
        { title: 'Occupied', code: 'HOLD' },
      ],

      // validation rules
      required,
    }
  },
  computed: {
    canCreateStaffHold() {
      return this.canViewThisAction('create-staff-hold', 'LotReservation')
    },
  },

  created() {
  },
  methods: {
    canViewThisAction,
    goBack() {
      this.$router.go(-1)
    },
    isSelectableOption(option) {
      if (!option) return false
      if (option.code === 'HOLD' && !this.canCreateStaffHold) {
        return false
      }
      return true
    },
    resolveStatusName(status) {
      const statusName = this.statusOptions.find(stat => stat.code === status)
      return statusName ? statusName.title : status
    },
    resolveStatusVariant(status) {
      if (status === 'OPEN') return 'success'
      if (status === 'RESERVE') return 'warning'
      if (status === 'BOOK') return 'danger'
      if (status === 'CONFIRM') return 'primary'
      if (status === 'HOLD') return 'info'
      return 'primary'
    },
    addSuiteSearchInput(suite) {
      this.showSuiteCrossIcon = true
      this.suiteQuery = `${suite.description} (${suite.code})`
      this.suiteName = suite.description
      this.suiteID = suite._id
      this.lotQuery = ''
      this.lotName = ''
      this.lotID = ''
      this.showLotCrossIcon = false
      this.searchLotResultNotFound = false
      this.showLotSearchResult = false
    },

    clearSuiteSearchInput() {
      this.suiteQuery = ''
      this.suiteName = ''
      this.suiteID = ''
      this.lotID = ''
      this.showSuiteCrossIcon = false
      this.searchSuiteResultNotFound = false
      this.showSuiteSearchResult = false

      this.lotQuery = ''
      this.lotName = ''
      this.lotID = ''
      this.showLotCrossIcon = false
      this.searchLotResultNotFound = false
      this.showLotSearchResult = false
    },

    fetchSuiteResults() {
      const { suiteQuery } = this
      clearTimeout(this.timeout)
      if (suiteQuery.length > 2) {
        this.timeout = setTimeout(() => {
          this.$http.get('reservation/reservations/respond-with/suites', { params: { search: suiteQuery } })
            .then(response => {
              if (response.data.suites.length === 0) {
                this.foundSuites = []
                this.searchSuiteResultNotFound = true
                this.showSuiteSearchResult = false
              } else {
                this.foundSuites = response.data.suites
                this.showSuiteSearchResult = true
                this.searchSuiteResultNotFound = false
              }
              this.suiteName = ''
              this.suiteID = ''
              this.lotID = ''
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            })
        }, this.debounceMilliseconds)
      }
    },
    resetSuiteSearchResult() {
      setTimeout(() => {
        this.searchSuiteResultNotFound = false
        this.showSuiteSearchResult = false
      }, 500)
    },

    addLotSearchInput(lot) {
      // eslint-disable-next-line eqeqeq
      if (lot.status == 'OPEN') {
        this.showLotCrossIcon = true
        this.lotQuery = lot.lotNo
        this.lotName = lot.lotNo
        this.lotID = lot._id
      } else {
        this.lotQuery = ''
      }
      this.lotData = lot
    },

    clearLotSearchInput() {
      this.lotQuery = ''
      this.lotName = ''
      this.lotID = ''
      this.lotData = {}
      this.showLotCrossIcon = false
      this.searchLotResultNotFound = false
      this.showLotSearchResult = false
    },

    fetchLotResults() {
      const { lotQuery } = this
      clearTimeout(this.timeout)
      if (lotQuery.length > 2 && this.suiteID) {
        this.timeout = setTimeout(() => {
          this.$http.get('reservation/reservations/respond-with/lots', { params: { search: lotQuery, suiteID: this.suiteID } })
            .then(response => {
              if (response.data.lots.length === 0) {
                this.foundLots = []
                this.searchLotResultNotFound = true
                this.showLotSearchResult = false
              } else {
                this.foundLots = response.data.lots
                this.showLotSearchResult = true
                this.searchLotResultNotFound = false
              }
              this.lotName = ''
              this.lotID = ''
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            })
        }, this.debounceMilliseconds)
      }
    },
    resetLotSearchResult() {
      setTimeout(() => {
        this.searchLotResultNotFound = false
        this.showLotSearchResult = false
      }, 500)
    },

    fetchAgentResults() {
      const { agentQuery } = this

      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.$http.get('reservation/reservations/respond-with/agents', { params: { search: agentQuery } })
          .then(response => {
            if (response.data.agents.length === 0) {
              this.foundAgents = []
              this.searchAgentResultNotFound = true
              this.showAgentSearchResult = false
            } else {
              this.foundAgents = response.data.agents
              this.showAgentSearchResult = true
              this.searchAgentResultNotFound = false
            }
            this.agentName = ''
            this.agentID = ''
            this.agentType = ''
            this.pAgentID = ''
            this.sclcAgentID = ''
            this.agentCode = '-'
          })
          .catch(error => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
      }, this.debounceMilliseconds)
    },
    resetAgentSearchResult() {
      setTimeout(() => {
        this.searchAgentResultNotFound = false
        this.showAgentSearchResult = false
      }, 500)
    },
    clearAgentSearchInput() {
      this.agentQuery = ''
      this.agentName = ''
      this.agentID = ''
      this.agentType = ''
      this.pAgentID = ''
      this.sclcAgentID = ''
      this.agentCode = '-'
      this.showAgentCrossIcon = false
      this.searchAgentResultNotFound = false
      this.showAgentSearchResult = false
    },
    setAgent(item) {
      this.showAgentCrossIcon = true
      this.agentQuery = item.name
      this.agentName = item.name
      this.agentCode = item.code
      this.agentType = item.modelType
      if (item.modelType === 'Agent') {
        this.agentID = item._id
        this.pAgentID = ''
        this.sclcAgentID = item.agentID
      } else {
        this.agentID = item.agent
        this.pAgentID = item._id
        this.sclcAgentID = item.agentID
      }
    },
    setReleaseDate(time = null, unit = null) {
      if (time) {
        this.releaseDate = moment().add(time, unit).toDate()
      } else {
        this.releaseDate = ''
      }
    },
    submitForm() {
      this.$refs.reservationCreateForm.validate().then(async success => {
        if (success && this.suiteID && this.lotID && this.agentID && this.sclcAgentID) {
          const formData = new FormData()

          formData.append('suiteID', this.suiteID)
          formData.append('lotID', this.lotID)
          formData.append('agentID', this.agentID)
          formData.append('pAgentID', this.pAgentID)
          formData.append('sclcAgentID', this.sclcAgentID)
          formData.append('remarks', this.remarks)
          formData.append('agentName', this.agentName)
          formData.append('agentCode', this.agentCode)
          formData.append('reservationFor', this.reservedFor)
          // formData.append('releaseDate', this.reservationStatus === 'HOLD' ? this.releaseDate : '')
          if (this.reservationStatus === 'HOLD') {
            const rDate = moment(this.releaseDate, 'DD/MM/YYYY, HH:mm')
            formData.append('releaseDate', new Date(rDate).toISOString())
          } else {
            formData.append('releaseDate', '')
          }
          formData.append('reservationStatus', this.reservationStatus)

          this.$http.post('reservation/suites/lot/reserve', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
            .then(response => {
              if (response.data.success) {
                this.$swal({
                  title: 'Reservation Created',
                  html: response.data.message || '',
                  // eslint-disable-next-line global-require
                  imageUrl: require('@/assets/images/icons/save.png'),
                  imageWidth: 80,
                  imageHeight: 80,
                  imageAlt: 'Custom Icon',
                  showCancelButton: true,
                  cancelButtonText: 'View Entry',
                  allowOutsideClick: false,
                  confirmButtonText: 'Return to Reservations',
                  customClass: {
                    confirmButton: 'btn btn-primary mr-1',
                    cancelButton: 'btn btn-primary',
                  },
                  buttonsStyling: false,
                })
                  .then(result => {
                    this.savedData = true
                    if (result.value) {
                      let type = 'reserved'
                      if (this.reservationStatus === 'HOLD') {
                        type = 'staff-hold'
                      }
                      this.$router.push({ name: 'agencies-reservations-index', params: { type } })
                    } else {
                      this.$router.push({ name: 'agencies-reservation-show', params: { id: response.data.reservation._id } })
                    }
                  })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: response.data.message || '',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
            .catch(error => {
              if (error.data.errors) {
                error.data.errors.forEach(validationError => {
                  if (validationError.param === 'suiteName') {
                    this.suiteNameError = validationError.msg
                    this.suiteNameValidation = true
                  }
                })

                const items = document.getElementsByClassName('text-danger')
                window.scrollTo({
                  top: items[0].offsetTop,
                  behavior: 'smooth',
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
        } else {
          const items = document.getElementsByClassName('is-invalid')
          if (items && items.length) {
            // window.scrollTo({
            //   top: items[0].offsetHeight + 100,
            //   behavior: 'smooth',
            // })
            items[0].scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'center',
            })
          }
        }
      })
    },
  },
}
</script>

<style scoped>
  .badge.text-capitalize.weight-600 {
    font-weight: 600 !important;
  }
  .custom-description {
    margin-top: -10px;
    margin-bottom: 5px;
  }
  .removeText {
    color:#D91B35;
    cursor: pointer;
  }
  .addOptionText {
    color: #104D9D;
    cursor: pointer;
  }
  .btn-group-toggle [class*=btn-outline-]:not(:last-child) {
    border-right-width: 1px !important;
  }
  .inlineElement {
    display: flex;
  }
  .step-class {
    color: #104D9D;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
  }
  .dropzone-custom-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }
  .dropzone-custom-title {
    margin-top: 0;
    color: #104D9D;
  }
  .subtitle {
    color: #333333;
  }
  .bookingCounter {
    border-radius: 50%;
    width: 5px;
    height: 5px;
    padding: 2px;

    background: #fff;
    border: 1px solid #666;
    color: #666;
    text-align: center;

    font-size: 10px;
  }

  .vs__dropdown-option--disabled {
    background: #ededed;
    color: #000000;
  }
  .sd-title {
    font-weight: 500;
    font-size: 15px;
    line-height: 24px;
  }
  .removeText {
    color:#D91B35;
    cursor: pointer;
  }
  .addOptionText {
    color: #104D9D;
    cursor: pointer;
  }
  .btn-group-toggle [class*=btn-outline-]:not(:last-child) {
    border-right-width: 1px !important;
  }
  .inlineElement {
    display: flex;
  }
  .step-class {
    color: #104D9D;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
  }
  .dropzone-custom-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }
  .dropzone-custom-title {
    margin-top: 0;
    color: #104D9D;
  }
  .subtitle {
    color: #333333;
  }
  .bookingCounter {
    border-radius: 50%;
    width: 5px;
    height: 5px;
    padding: 2px;

    background: #fff;
    border: 1px solid #666;
    color: #666;
    text-align: center;

    font-size: 10px;
  }
  .z-index-99{
     z-index: 99;
  }
  .result-search-header{
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    text-align: left;
    color: #333333;
  }
.card-body .input-group .input__append-border-right{
    border-right: 1px solid #D2DCEA !important;
}
.card-body .input-group .input__append-border-right:focus{
       border-color: #104D9D !important;
  }
  .item-img-block.suite-img {
    width: 50px;
    height: 46.45px;
    border-radius: 6px;
  }
  .search-item-text-block.no-ml {
    margin-left: 0;
  }
  .danger__alert {
    border-radius: 4px;
    background: rgba(217, 27, 53, 0.15) !important;
  }
  .form-control.input__append-border-right.is_invalid {
    border-color: #D91B35 !important;
    border-right: 1px solid #D91B35;
  }
</style>
